module.exports = __webpack_public_path__ + "static/media/sopt17kz.23b176bd.pdf";